<template>
  <div class="to-categories">
    <div class="to-categories-container">
      <div class="to-categories__header">
        <h3>Opgaveoversigt kategorier {{ schoolYear.name }}</h3>
        <button class="do-bttn do-bttn--submit" @click="$emit('setCreateCategory', true)">
          Opret ny kategori
        </button>
      </div>
      <h4 class="text-explainer" v-if="taskCategories.length < 1">Ingen kategorier</h4>
      <draggable v-model="taskCategoriesOrder" @change="onChangeOrder">
        <transition-group type="transition" name="flip-list" tag="ul">
          <li v-for="(taskCategory, key) in taskCategoriesOrder" :key="taskCategory.id"
              class="to-categories-container__category__container">
            <div class="to-categories-container__category">
              <div>
                <div class="to-categories-container__category__number">
                  <span>{{ key + 1 }}</span>
                  <div
                    class="icon__bg-circle icon__bg-circle--move"
                    :content="'Flyt op eller ned for at sortere'"
                    v-tippy="{
                      arrow: false,
                        placement : 'top',
                        animation : 'shift-away',
                        zIndex: '999999992',
                        boundary: 'window'
                  }">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                         id="Capa_1" x="0px" y="0px" width="13px" height="13px" viewBox="0 0 572.156 572.156"
                         style="enable-background:new 0 0 572.156 572.156;" xml:space="preserve">
                <g>
                  <polygon
                    points="495.405,241.769 418.657,197.457 418.657,258.115 314.042,258.115 314.042,153.498 374.699,153.498    330.389,76.751 286.078,0 241.769,76.751 197.457,153.498 258.115,153.498 258.115,258.115 153.498,258.115 153.498,197.457    76.751,241.767 0,286.078 76.751,330.387 153.498,374.699 153.498,314.042 258.115,314.042 258.115,418.657 197.457,418.657    241.767,495.405 286.078,572.156 330.387,495.405 374.699,418.657 314.042,418.657 314.042,314.042 418.657,314.042    418.657,374.699 495.405,330.389 572.156,286.078  "/>
                </g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
              </svg>
                  </div>
                </div>
                <div class="to-categories-container__category__text">
                  <div class="to-input-and-button" v-if="getIsTheEditTask(taskCategory)">
                    <input type="text" class="d-input"
                           v-model="theEditTask.name"
                           v-focus
                           @keyup.enter="saveEditTask"
                           @keyup.esc.stop="setEditTask(null)">
                    <button class="do-bttn do-bttn--submit"
                            :class="{'do-bttn--submit--loading': theUpdatingTaskId === taskCategory.id}"
                            @click="saveEditTask">Gem
                    </button>
                    <button class="do-bttn" @click="setEditTask(null)">Annuller</button>
                    <div
                      v-if="taskCategory.v_is_used_on_subjects.length === 0"
                      class="icon__bg-circle icon__bg-circle--danger"
                      :content="$t('vue2.common.delete')"
                      v-tippy="{
                          arrow: false,
                        placement : 'top',
                        animation : 'shift-away',
                        zIndex: '999999992',
                        boundary: 'window'
                      }"
                      @click="setTheDeleteTaskCategory(taskCategory)">
                      <span class="icon-bin"></span>
                    </div>
                    <div class="icon__bg-circle icon__bg-circle--danger cursor-not-allowed"
                         v-else
                         :content="'Kan ikke slettes, da den bruges på ' + taskCategory.v_is_used_on_subjects.length + ' fag/opgaver'"
                         v-tippy="{
                    arrow: false,
                    placement : 'top',
                    animation : 'shift-away',
                    zIndex: '999999992',
                    boundary: 'window'
                  }">
                      <span class="icon-bin" style="opacity: 0.5"></span>
                    </div>
                  </div>
                  <template v-else>
                    {{ taskCategory.name }}
                    <div
                      class="icon__bg-circle"
                      :content="$t('vue2.common.edit')"
                      @click="setEditTask(taskCategory)"
                      v-tippy="{
                    arrow: false,
                    placement : 'top',
                    animation : 'shift-away',
                    zIndex: '999999992',
                    boundary: 'window'
                  }">
                      <span class="icon-pencil"></span>
                    </div>
                  </template>
                </div>
              </div>
              <div>
                <select class="do-select"
                        v-model="selectedItem"
                        @change="onAddSubjectType(taskCategory, $event.target.value)">
                  <option disabled selected value="null">Tilføj briktype til kategorien</option>
                  <option v-for="option in getFilteredDbSubjectTypes(taskCategory)" :value="option.key">
                    {{ option.v_title }}
                  </option>
                </select>
              </div>
            </div>
            <ul class="to-categories-container__category__subject-types dropzone"
                :class="{'dropzone--active': dragEvt && draggedFromCategoryId !== taskCategory.id}"
                ref="droppable_elements"
                @dragover.prevent
                @dragenter.prevent="dragEnter(taskCategory, $event)"
                @dragleave.prevent="dragLeave"
                @drop.prevent="drop(taskCategory, $event)">
              <li class="text-explainer" v-if="taskCategory.v_subject_types.length === 0">Ingen kategorier</li>
              <li class="d-tag cursor-grab" v-for="subjectType in taskCategory.v_subject_types" :key="subjectType.key"
                  draggable="true"
                  @dragstart.stop="dragStart(subjectType, taskCategory.id, $event)"
                  @dragend.stop="dragEnd(subjectType, $event)"
                  @dragover.stop
                  @drop.prevent="drop(taskCategory, $event)">
                {{ subjectType.v_name }}
              </li>
            </ul>
          </li>
        </transition-group>
      </draggable>
    </div>
    <DModal :show-close="false" :isBgOverlay="false" :placeInTop="true"
            @close="setTheDeleteTaskCategory(null)"
            :appendToBody="true"
            style="z-index: 123123"
            :isCloseOnEsc="true"
            v-if="theDeleteTaskCategory">
      <div class="brutto-warning text-dark" slot="insertComponent">
        <div class="brutto-warning__header">
          <h2>Er du sikker</h2>
          <div class="icon__bg-circle doc-modal__close" @click="setTheDeleteTaskCategory(null)">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="brutto-warning__body">
          <svg class="tw-icon tw-icon--red" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <template v-if="theDeleteTaskCategory.v_subject_types && theDeleteTaskCategory.v_subject_types.length > 0">
            <h4>Før du kan slette denne kategori, skal du vælge en ny kategori til dens standard briktyper.</h4>
            <ul class="list-order-items">
              <li v-for="subjectType in theDeleteTaskCategory.v_subject_types" :key="subjectType.key">
                <b>{{ subjectType.v_name }}</b>
                <select :value="null" class="do-select"
                        @change="onChangeCategoryForSubjectType($event.target.value, subjectType.key)">
                  <option :value="null" disabled>Vælg ny kategori..</option>
                  <option v-for="option in getTaskCategoriesOrder" :value="option.id">
                    {{ option.name }}
                  </option>
                </select>
              </li>
            </ul>
          </template>
          <p class="text-explainer" v-else>
            Vil du slette kategorien permanent?
          </p>
        </div>
        <div class="brutto-warning__footer">
          <button class="do-bttn" @click="setTheDeleteTaskCategory(null)">Annullér</button>
          <button class="do-bttn do-bttn--submit do-bttn--submit--disabled"
                  v-if="theDeleteTaskCategory.v_subject_types.length > 0">Slet
          </button>
          <button class="do-bttn do-bttn--submit do-bttn--danger" v-else
                  :class="[{'do-bttn--submit--loading': theDeletedCategoryId === theDeleteTaskCategory.id}]"
                  @click="deleteTaskCategory(theDeleteTaskCategory)">Slet
          </button>
        </div>
      </div>
    </DModal>
  </div>
</template>

<script>
import docendo from '../../docendo'
import draggable from 'vuedraggable'
import DModal from '../common/DModal.vue'

export default {
  components: {DModal, draggable},
  props: {
    schoolId: {},
    schoolYearId: {},
    schoolYear: {
      name: ''
    },
    taskCategories: {
      type: Array,
      default: () => []
    },
    dbSubjectTypes: {
      type: Array,
      default: () => []
    },
    locale: {
      default: 'da'
    },
    subjects: {
      type: Array,
      default: () => []
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
      }
    }
  },
  data () {
    return {
      taskCategoriesOrder: [],
      theEditTask: null,
      theUpdatingTaskId: null,
      selectedItem: null,
      theDeleteTaskCategoryId: null,
      theDeletedCategoryId: null,
      dragEvt: null,
      draggedSubjectType: null,
      draggedFromCategoryId: null,
      oldCategoryName: ''
    }
  },
  computed: {
    theDeleteTaskCategory () {
      return this.theDeleteTaskCategoryId !== null
        ? this.taskCategoriesOrder.find(taskCat => taskCat.id === this.theDeleteTaskCategoryId * 1) || null
        : null
    },
    dbSubjectTypesTranslated () {
      return this.dbSubjectTypes
        .map(subjectType => ({
          key: subjectType.key,
          v_title: this.getTranslatedSubjectType(subjectType) // Fallback hvis oversættelse mangler
        }))
        .sort((a, b) => a.v_title.localeCompare(b.v_title)) // Sortering efter v_title
    },
    getTaskCategoriesOrder () {
      return this.taskCategoriesOrder.filter(taskCat => taskCat.id !== this.theDeleteTaskCategoryId)
    },
    schoolSettingShownOwnPools () {
      return this.$store.getters.shownOwnPools
    }
  },
  watch: {
    taskCategories (val) {
      this.setAllCategories()
    }
  },
  methods: {
    getIsUsedOnSubjects (taskCategory) {
      return this.subjects.filter(subject => subject.selected_task_category_id === taskCategory.id)
    },
    resetDrag () {
      this.dragEvt.target.classList.remove('isDragging')
      this.dragEvt.target.style.display = ''
      this.dragEvt = null
      this.draggedSubjectType = null
      this.draggedFromCategoryId = null
    },
    dragStart (subjectType, draggedFromCategoryId, evt) {
      this.draggedSubjectType = subjectType
      this.draggedFromCategoryId = draggedFromCategoryId
      this.dragEvt = evt
      this.dragEvt.target.classList.add('isDragging')
    },
    dragEnd () {
      if (!this.dragEvt) {
        return
      }
      this.resetDrag()
    },
    dragEnter (taskCategory, evt) {
      if (!this.dragEvt) {
        return
      }
      evt.target.classList.add('isDragEnter')
    },
    dragLeave (evt) {
      if (!this.dragEvt) {
        return
      }
      evt.target.classList.remove('isDragEnter')
    },
    drop (taskCategory, evt) {
      if (!this.dragEvt) {
        return
      }
      if (this.draggedFromCategoryId !== taskCategory.id) {
        this.onAddSubjectType(taskCategory, this.draggedSubjectType.key)
      }
      this.dragEnd()
      let elements = this.$refs.droppable_elements
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.remove('isDragEnter')
      }
    },
    setTheDeleteTaskCategory (taskCategory) {
      if (!taskCategory) {
        this.setEditTask(null)
        this.theDeleteTaskCategoryId = null
      }
      this.theDeleteTaskCategoryId = taskCategory.id
    },
    getFilteredDbSubjectTypes (taskCategory) {
      const excludedTypes = ['absence', 'flexin', 'flexout', 'with_kids', 'without_kids', 'exercise', 'reservation', 'frame']
      const allExcludedTypes = excludedTypes.concat(taskCategory.subject_types)
      return this.dbSubjectTypesTranslated.filter(subjectType => !allExcludedTypes.includes(subjectType.key))
    },
    onChangeCategoryForSubjectType (taskCategoryId, subjectType) {
      const newTaskCategory = this.taskCategories.find(category => category.id === taskCategoryId * 1)
      this.onAddSubjectType(newTaskCategory, subjectType)
    },
    onAddSubjectType (taskCategory, val) {
      // Find nuværende ejer af subjectType
      const currentTaskCategory = this.taskCategories.find(category =>
        category.subject_types.includes(val)
      )

      if (currentTaskCategory) {
        const currentTaskCategoryTypes = currentTaskCategory.subject_types.filter(subjectType => subjectType !== val)
        this.updateSubjectTypesOnCategory(currentTaskCategory, currentTaskCategoryTypes)
      }

      // Opdater ny subject_type ejer
      if (!taskCategory.subject_types.includes(val)) {
        const updatedSubjectTypes = [...taskCategory.subject_types, val] // Opretter en ny kopi af arrayet
        this.updateSubjectTypesOnCategory(taskCategory, updatedSubjectTypes)
      }
    },
    updateSchoolSettings (setting, isDelete = false) {
      if (!isDelete && this.oldCategoryName === setting) {
        return
      }
      const saveKey = 'shownOwnPools'
      const oldSettingName = !isDelete ? this.oldCategoryName : setting
      const arr = [...this.schoolSettingShownOwnPools] // Opret ny kopi af arrayet
      const index = arr.indexOf(oldSettingName)

      if (index !== -1) {
        arr.splice(index, 1) // Fjern setting, hvis den findes
        if (!isDelete) {
          arr.push(setting)
        }
      }
      if (arr.length > 0) {
        this.$store.dispatch('updateSchoolSettings', {[saveKey]: arr})
      } else {
        if (this.schoolSettings[saveKey]) {
          this.$store.dispatch('deleteSchoolSetting', saveKey)
        }
      }
    },
    updateSubjectTypesOnCategory (taskCategory, subjectTypes) {
      docendo.updateTaskCategory(
        this.schoolId,
        this.schoolYearId,
        taskCategory.id,
        taskCategory.name,
        taskCategory.rank,
        subjectTypes,
        success => {
          this.$emit('updateCategory', success)
          this.setEditTask(null)
          this.theUpdatingTaskId = null
          this.selectedItem = null
        },
        failure => {
          console.log('Failed to update category')
          this.setEditTask(null)
          this.theUpdatingTaskId = null
        })
    },
    saveEditTask () {
      if (this.theEditTask.name.length === 0) {
        window.alert('må ikke være tom')
        return
      }
      this.theUpdatingTaskId = this.theEditTask.id
      docendo.updateTaskCategory(
        this.schoolId,
        this.schoolYearId,
        this.theEditTask.id,
        this.theEditTask.name,
        this.theEditTask.rank,
        this.theEditTask.subject_types,
        success => {
          this.updateSchoolSettings(success.name, false)
          this.$emit('updateCategory', success)
          this.setEditTask(null)
          this.theUpdatingTaskId = null
        },
        failure => {
          console.log('Failed to update category')
          this.setEditTask(null)
          this.theUpdatingTaskId = null
        })
    },
    getIsTheEditTask (taskCategory) {
      return this.theEditTask && this.theEditTask.id === taskCategory.id
    },
    setEditTask (taskCategory) {
      if (taskCategory) {
        this.oldCategoryName = taskCategory.name
      } else {
        this.oldCategoryName = ''
      }
      this.theEditTask = JSON.parse(JSON.stringify(taskCategory))
      this.$emit('onSetEditTask', taskCategory)
    },
    deleteTaskCategory (taskCategory) {
      this.theDeletedCategoryId = taskCategory.id
      docendo.deleteTaskCategory(this.schoolId, this.schoolYearId, this.theDeletedCategoryId, success => {
        this.updateSchoolSettings(taskCategory.name, true)
        this.$emit('onDeleteTaskCategory', this.theDeletedCategoryId)
        this.theDeletedCategoryId = null
        this.setTheDeleteTaskCategory(null)
      }, failure => {
        console.log('failure')
      })
    },
    onChangeOrder (evt) {
      // Hent det flyttede element og dets nye og gamle indekser
      const movedCategory = evt.moved.element
      // const oldIndex = evt.moved.oldIndex
      const newIndex = evt.moved.newIndex

      // Find de omkringliggende kategorier, der er tæt på det flyttede element
      const prevCategory = this.taskCategoriesOrder[newIndex - 1]
      const nextCategory = this.taskCategoriesOrder[newIndex + 1]

      // Beregn det nye rank for det flyttede element
      let newRank
      if (prevCategory && nextCategory) {
        // Hvis der er både en kategori før og efter, beregn gennemsnittet af deres ranks
        newRank = (prevCategory.rank + nextCategory.rank) / 2
      } else if (prevCategory) {
        // Hvis der kun er kategorier før, sæt rank lidt højere
        newRank = prevCategory.rank + 1
      } else if (nextCategory) {
        // Hvis der kun er kategorier efter, sæt rank lidt lavere
        newRank = nextCategory.rank - 1
      } else {
        // Hvis der ikke er nogen omkringliggende kategori, brug et default rank
        newRank = movedCategory.rank
      }

      // Opdater den flyttede kategori med den nye rank
      movedCategory.rank = newRank

      // Opdater kun den flyttede kategori på serveren
      docendo.updateTaskCategory(
        this.schoolId,
        this.schoolYearId,
        movedCategory.id,
        movedCategory.name,
        movedCategory.rank,
        movedCategory.subject_types,
        success => {
          this.$emit('updateCategory', success)
        },
        failure => {
          console.log(`Failed to update category ${movedCategory.id}`)
        }
      )
    },
    getTranslatedSubjectType (subjectType) {
      return subjectType && subjectType.i18n && subjectType.i18n[this.locale] || subjectType.key
    },
    setAllCategories () {
      this.taskCategoriesOrder = this.taskCategories
        .map(taskCategory => ({
          ...taskCategory,
          v_is_used_on_subjects: this.getIsUsedOnSubjects(taskCategory),
          v_subject_types: taskCategory.subject_types
            .map(subjectType => {
              const dbSubjectType = this.dbSubjectTypes.find(dbSubjectType => dbSubjectType.key === subjectType)
              return {
                key: subjectType,
                v_name: this.getTranslatedSubjectType(dbSubjectType)
              }
            })
        }))
        .sort((a, b) => a.rank - b.rank)
    }
  },
  mounted () {
    this.setAllCategories()
  },
  beforeDestroy () {
    this.setEditTask(null)
  }
}
</script>


<style scoped>
@import "../../assets/css/variables.css";

.to-categories-container {
  background: #fff;
  border: 1px solid #e2e8f0;
  padding: 1rem 2rem 2rem 2rem;
  border-radius: 4px;
  margin: 1rem 1rem 0 0;
}

.to-categories__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.to-categories-container__category__container {
  position: relative;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  transition: transform .25s, background-color .25s, box-shadow .25s;
  cursor: move;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  margin-bottom: 0.5rem;
}

.icon__bg-circle.icon__bg-circle--move {
  cursor: move;
}

.to-categories-container__category {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  font-weight: bold;
  border-bottom: 1px solid #e2e8f0;
  padding-right: 0.5rem;
  background: #f6f9fc;
}

.to-categories-container__category__subject-types {
  padding: 0.5rem 1rem;
  display: flex;
  gap: 0.5rem;
  flex-wrap: nowrap;
}

.to-categories-container__category__container:hover {
  background-color: #f9fafc;
  transform: translateY(-2px);
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, .2);
}

.to-categories-container__category > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.to-categories-container__category__number {
  padding: 0;
  width: 34px;
  height: 34px;
  display: flex;
  border-radius: 4px 0 0 4px;
  align-items: center;
  justify-content: center;
}

.to-categories-container__category__number > .icon__bg-circle {
  display: none;
}

.to-categories-container__category__container:hover .to-categories-container__category__number > .icon__bg-circle {
  display: flex;
}

.to-categories-container__category__container:hover .to-categories-container__category__number > span {
  display: none;
}

.to-categories-container__category__text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.to-categories-container__category__text > .icon__bg-circle {
  opacity: 0;
}

.to-categories-container__category__container:hover .icon__bg-circle {
  opacity: 1;
}

.to-input-and-button {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.to-input-and-button > input {
  min-width: 220px;
}

.to-input-and-button > .icon__bg-circle {
  min-width: 30px;
}

.d-tag {
  align-items: center;
  padding: 1px 5px;
  border-radius: 4px;
  color: #333;
  border: 1px solid #c8d6e2;
  background: #f6f9fc;
  font-size: 11px;
  font-weight: 500;
  transition: background-color .02s;
}

.to-categories-container__category__container .d-label {
  padding: 0.5rem 1rem 0;
}

.list-order-items {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.list-order-items li {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  border: 1px solid #eee;
  padding: 0.5rem;
}

.dropzone--active .d-tag {
  pointer-events: none;
}

.dropzone--active {
  background: aliceblue;
}

.dropzone--active.isDragEnter {
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(64, 68, 82, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(64, 68, 82, 0.08) 0px 2px 5px 0px;
}

.cursor-grab {
  cursor: grab;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

</style>




// WEBPACK FOOTER //
// TaskOverviewSettingsCategories.vue?414a9ece